import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot, UrlSegment, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { LanguagesService } from '@app/services';

@Injectable({
  providedIn: 'root'
})
export class LanguageGuard implements CanActivate {
    
    constructor (
        private router: Router,
        private languagesService : LanguagesService
    ) {}
    
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {             
            return this.initLanguages();
    }
        
    async initLanguages(){
        await this.languagesService.init();
        return true;
    }
}
